export function getLeftArrowState(offset) {
    return offset < 0 ? true : false;
}
//# sourceMappingURL=getLeftArrowState.js.map